const KG_PER_LB = 0.45359237;
const LB_PER_KG = 1 / KG_PER_LB;

export function roundWeight(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return null;
  return Math.round(n * 100) / 100;
}

export function kgToLbs(kg) {
  const n = Number(kg);
  if (!Number.isFinite(n)) return null;
  return roundWeight(n * LB_PER_KG);
}

export function lbsToKg(lbs) {
  const n = Number(lbs);
  if (!Number.isFinite(n)) return null;
  return roundWeight(n * KG_PER_LB);
}

export function pairWeightFromKg(kg) {
  const weight_kg = roundWeight(kg);
  if (weight_kg == null) return { weight_kg: null, weight_lbs: null };
  return { weight_kg, weight_lbs: kgToLbs(weight_kg) };
}

export function pairWeightFromLbs(lbs) {
  const weight_lbs = roundWeight(lbs);
  if (weight_lbs == null) return { weight_kg: null, weight_lbs: null };
  return { weight_kg: lbsToKg(weight_lbs), weight_lbs };
}

export function weightInKgFlag(user) {
  if (!user) return true;
  const v = user.weightInKg ?? user.weight_in_kg;
  if (v === false || v === 'false' || v === 0) return false;
  return true;
}

export function getDisplayWeight(setRow, weightInKg) {
  if (!setRow) return null;
  if (weightInKg) {
    return setRow.weight_kg != null ? roundWeight(setRow.weight_kg) : null;
  }
  return setRow.weight_lbs != null ? roundWeight(setRow.weight_lbs) : null;
}

export function weightStep(weightInKg, fast = false) {
  if (weightInKg) return fast ? 10 : 2.5;
  return fast ? 20 : 5;
}
